import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.wallets.kyc.TermsAndPolicy', {
    back: 'Back',
    getStarted: 'Get started',
    next: 'Next',
    byClicking: 'By clicking "{actionName}", you agree to our {terms}{br}and {policy}',
    terms: 'Terms and conditions',
    privacy: 'Privacy policy',
});
